export default "__VITE_ASSET__4dN3SBIN__"